<template>
    <div class="c-app-nav">
        <!-- <div class="w-card-title">其他应用</div> -->
    </div>
</template>
<script>
export default {
    name: "AppNav",
};
</script>
<style lang="less" scoped>
.c-app-nav {
    padding: 10px;
    .el-divider {
        margin: 10px 0;
    }
}
</style>
